// 繁體中文表格（機器翻譯，未經人工審校 — ruling G4）。
// The Traditional Chinese table: machine-written from the English table, unread by a native
// reader. Same keys, kinds and placeholders as en.js — held by test/tables.test.js.
import { FITS, DEPTH, SNAP, snapOverlap, fmt } from '../doc.js';
const S = {
  title: "帶標誌的咖啡杯",
  gLogo: "杯上的標誌",
  gSize: "杯子尺寸",
  gColour: "顏色",
  gLid: "蓋子與列印",
  loadingFont: (family, got, total) => (total > 0 ? `正在載入 ${family} ${got.toFixed(1)} / ${total.toFixed(1)} MB` : `正在載入 ${family} ${got.toFixed(1)} MB`),
  needFile: "選擇標誌的 SVG 檔案——它只留在您的裝置上，不會傳送到任何地方",
  artKept: "標誌只存在於目前分頁——重新整理後需重新選擇檔案",
  keptOld: "（仍在使用先前的標誌）",
  thumb: "已讀取標誌的預覽",
  mode: "標誌風格",
  modes: {
    flush: "齊平",
    raised: "凸起",
    engraved: "雕刻",
  },
  styleLabel: "杯型",
  styles: {
    classic: "經典杯型",
    thin: "真正薄壁",
  },
  modeNote: (style, mode) => {
      if (mode === 'raised') return `凸起 ${fmt(DEPTH[style].raised[1])} 公厘——多色和單色印表機都可用（單色時呈現為浮雕）`;
      if (mode === 'engraved') return `雕刻 ${fmt(DEPTH[style].engraved[0])} 公厘深，標誌不單獨成件——適合單色印表機`;
      const flush = '與杯面齊平——面向多色印表機（單色時看不到標誌）';
      return style === 'thin' ? `${flush} 薄壁：標誌厚 ${fmt(DEPTH.thin.flush[0])} 公厘；深色杯身上的淺色標誌可能偏暗——要紮實的顏色請選凸起` : flush;
    },
  scale: "標誌大小",
  pos: "上下移動",
  hideThin: "隱藏過薄、無法列印的部分",
  signedPercent: (v) => `${v > 0 ? '+' : ''}${Math.round(v * 100)}%`,
  size: "尺寸",
  presets: {
    mini: "迷你",
    s: "S",
    m: "M",
    l: "L",
  },
  d: "直徑（公厘）",
  adjusted: (v, lo, hi) => `已設為 ${v} 公厘（可用範圍 ${lo}–${hi} 公厘）`,
  looks: "配色",
  lookNames: {
    mono: "黑白",
    kraft: "牛皮紙",
    white: "白色",
  },
  parts: {
    body: "杯子",
    ring: "掛環",
    logo: "標誌",
  },
  colour: {
    body: "杯身顏色",
    lid: "蓋子顏色",
    ring: "掛環顏色",
    logo: "標誌顏色",
  },
  lidOn: "加一個蓋子",
  ringOn: "掛環",
  fit: "蓋子鬆緊",
  fits: {
    tight: "非常緊",
    snug: "貼緊",
    normal: "略鬆",
    loose: "寬鬆",
  },
  fitNote: (style, fit, d) => {
      if (style !== 'thin') return `${fmt(FITS[fit])} 公厘邊距——蓋子靠摩擦扣住，沒有卡扣`;
      if (fit === 'loose') return `蓋子寬鬆、不卡扣——每側 ${fmt(SNAP.loose.c)} 公厘邊距`;
      return `蓋子卡在杯緣下——卡扣搭接 ${snapOverlap(SNAP[fit], d).toFixed(2)} 公厘`;
    },
  partLabel: "已下載的檔案",
  partNames: {
    set: "設定",
    cup: "杯子",
    lid: "蓋子",
  },
  lift: "掀開蓋子",
  outer: (d, h) => `ø ${d} × ${h} 公厘`,
  footprint: (w, d) => `列印占地 ${w} × ${d} 公厘`,
  capacity: (ml) => `容量 ${ml} 毫升`,
  problem: {
    "thin-text": "字母很細——有些筆畫可能列印不出來；請用更大的杯子或減少字元",
    "thin-parts": "標誌的細筆畫連著厚實部分——切片軟體可能把它們切掉",
    dropped: (p) => `已從標誌中捨棄 ${p.n} 個過薄、無法列印的部分`,
    "all-thin": "標誌對這個杯徑來說太薄——無法下載",
    "art-too-complex": "標誌太複雜——無法下載",
  },
  hairline: "限制：標誌上連著厚實部分的極細筆畫無法被偵測，切片軟體可能將其切掉——列印前請在切片軟體裡檢查預覽",
  dlstl: "STL",
  copied: "已複製",
  fatal: "無法載入計算器——請嘗試重新整理頁面",
  buildTimeout: (src) => (src === 'svg' ? '產生 10 秒未完成，已重新開始——請換更簡單的檔案' : '產生 10 秒未完成，已重新開始——請減少字元或換字型'),
  aboutP: "設計帶蓋的迷你咖啡杯 — 杯身放名字或店標，自選尺寸、顏色和蓋子鬆緊，免費下載 3MF/STL。這是裝飾模型，不是飲用容器。",
};
export default S;
